define('glu/listBuilder/defaultLabelView',['require','../itemView','hbs!./defaultLabelView.hbs'],function(require) {
    'use strict';

    var ItemView = require('../itemView');

    return ItemView.extend({
        template: require('hbs!./defaultLabelView.hbs')
    });
});

